import { render, staticRenderFns } from "./EipSubPagination.vue?vue&type=template&id=0b35af36&"
import script from "./EipSubPagination.vue?vue&type=script&lang=js&"
export * from "./EipSubPagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports